<template>
  <Panel
    :icon="['fas', 'link']"
    :loading="loading"
    loader-text="Loading Ringba Integration Settings"
  >
    <template v-slot:header>
      Ringba Integration
    </template>
    <template v-slot:content>
      <div class="integration-settings">
        <ManageRingbaApiToken />
      </div>
    </template>
  </Panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ManageRingbaApiToken from './ManageRingbaApiToken.vue'

export default {
  name: 'RingbaIntegration',
  
  title: 'Ringba Integration',
  
  components: {
    ManageRingbaApiToken
  },
  
  data() {
    return {
      loading: false,
      fetchTokensError: null
    }
  },
  
  computed: {
    ...mapGetters('auth', ['accountId'])
  },
  
  async created() {
    await this.fetchRingbaTokens()
  },
  
  methods: {
    ...mapActions('ringbaTokens', ['fetchTokens']),
    
    async fetchRingbaTokens() {
      this.loading = true
      this.fetchTokensError = null
      
      try {
        await this.fetchTokens({ accountId: this.accountId })
      } catch (error) {
        this.fetchTokensError = 'Failed to load Ringba tokens'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Panel component handles the main layout styling
</style>